import script from "./PluginManage.vue?vue&type=script&setup=true&lang=js"
export * from "./PluginManage.vue?vue&type=script&setup=true&lang=js"

import "./PluginManage.vue?vue&type=style&index=0&id=853d478e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-853d478e"]])

export default __exports__